var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('img',{staticClass:"logo",staticStyle:{"margin":"50px 0"},attrs:{"src":require("../../assets/img/futuronetwork-logo--white.png"),"alt":"FutureNetwork"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-878c4e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/ErrorLogo.vue
// module id = LFQx
// module chunks = 0